module.exports = __webpack_public_path__ + "img/thank-img.55608148.png";